import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { meetingApi, type CreateScheduledPayload, type MeetingStatus } from './meeting.api';

const KEY = ['meetings'];

export function useMyMeetings(params: { status?: MeetingStatus; search?: string; page?: number } = {}) {
  return useQuery({
    queryKey: [...KEY, params],
    queryFn: () => meetingApi.listMine(params),
  });
}

export function useCreateInstant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (title?: string) => meetingApi.createInstant(title),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useScheduleMeeting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateScheduledPayload) => meetingApi.createScheduled(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useCancelMeeting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => meetingApi.cancel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
